// extracted by mini-css-extract-plugin
export default {"container":"GalleryGridReview_container__SlwcI","note":"GalleryGridReview_note__YShZg","rating-wrapper":"GalleryGridReview_rating-wrapper__o2v-4"};